import PropTypes from "prop-types";
import React from "react";

import FormCheckbox from "../../components/form/FormCheckbox";
import { PropTypeShapes } from "../../types";
import Icon from "../interface/Icon";
import InspectorGroupHeading from "./InspectorGroupHeading";

const InspectorGroup = props => (
  <div
    className={`${props.className || ""} inspectorGroup ${props.disabled ? "disabled" : ""} ${
      props.noBottomLine ? "noBottomLine" : ""
    }`}
  >
    {props.showCheckbox ? (
      <InspectorGroupHeading>
        <FormCheckbox
          label={props.label}
          checkboxState={props.isChecked}
          disabled={props.disabled}
          onChange={props.onChange}
        />
      </InspectorGroupHeading>
    ) : props.label ? (
      <InspectorGroupHeading>
        <div className="inspectorGroupHeadingLabel">{props.label}</div>
        {props.headingComponents || props.rightIcon ? (
          <div className="inspectorGroupHeadingContent">
            {props.headingComponents}
            {props.rightIcon ? (
              <Icon
                icon={props.rightIcon}
                color="iconMono"
                onClick={props.onRightIconClick}
                className={props.rightIconDisabled ? "disabled" : ""}
                tooltip={props.rightIconTooltip}
              />
            ) : null}
          </div>
        ) : null}
      </InspectorGroupHeading>
    ) : null}
    {!props.showCheckbox || props.isChecked ? props.children : null}
  </div>
);

InspectorGroup.propTypes = {
  label: PropTypes.string,
  children: PropTypeShapes.elementOrArray,
  showCheckbox: PropTypes.bool,
  isChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  noBottomLine: PropTypes.bool,
  onChange: PropTypes.func,
  headingComponents: PropTypeShapes.elementOrArray,
  rightIcon: PropTypes.string,
  rightIconDisabled: PropTypes.bool,
  rightIconTooltip: PropTypes.string,
  onRightIconClick: PropTypes.func,
  className: PropTypes.string
};

export default InspectorGroup;
